import { useTranslation } from 'next-i18next'

import { ProductCategory } from '~/types/tutoring-api'

export default function SessionType({ type }: { type: ProductCategory }): React.ReactElement {
  const { t } = useTranslation('generics')
  const sessionTypeColor = getSessionTypeColor(type)

  return <div className={`text-md font-semibold ${sessionTypeColor}`}>{t(type)}</div>
}

function getSessionTypeColor(type: ProductCategory): string {
  switch (type) {
    case ProductCategory.TUTORING:
      return 'text-blue-iris'

    case ProductCategory.VIDEO_CHAT:
      return 'text-hotpink'

    default:
      return 'text-black'
  }
}
